import React from "react";

const StaticScreen = ({ obj }) => {
  return (
    <div
      className=""
      style={{
        marginTop: "10px",
        height: "100%",
        width: obj.width ? obj.width : "90%",
        position: "relative",
        transformOrigin: obj.transform_origin ? obj.transform_origin : null,
        maxWidth: "700px",
        top: obj.top ? obj.top : 0,
        left: obj.left ? obj.left : 0,
      }}
    >
      <img
        alt="tv-screen"
        src={obj.src}
        className={obj.push_left ? "alter-position-left" : null}
        style={{
          height: "auto",
          width: "99.6%",
          position: "absolute",
          zIndex: "199",

          margin: obj.margin ? obj.margin : null,
        }}
      />

      {obj.bezel ? (
        <img
          className={obj.push_left ? "alter-position-left" : null}
          alt="bezel"
          src={obj.bezel}
          style={{
            height: "auto",
            width: "100%",
            position: "absolute",

            zIndex: "200",
          }}
        />
      ) : null}
    </div>
  );
};

export default StaticScreen;
